import { computed } from 'mobx';
import getStore from '../store/store';
import { isFolderPaused } from 'owa-mail-list-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';

const FAVICON_RELATIVE_PATH = 'resources/images/favicons';
const MAIL_SEEN_FAVICON = `${FAVICON_RELATIVE_PATH}/mail-seen.ico`;
const MAIL_UNSEEN_FAVICON = `${FAVICON_RELATIVE_PATH}/mail-unseen.ico`;

export default computed(function mailFaviconProvider(): string {
    if (getStore().unseenMessages === 0 || isFolderPaused(folderNameToId('inbox'))) {
        return MAIL_SEEN_FAVICON;
    } else {
        return MAIL_UNSEEN_FAVICON;
    }
});

export { IComputedValue } from 'mobx';
